import { render } from "./ItemCompendiumModal.vue?vue&type=template&id=b0a54ba2"
import script from "./ItemCompendiumModal.vue?vue&type=script&lang=js"
export * from "./ItemCompendiumModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__